import { useContext, useEffect, useRef, useState } from "react";
import { SettingsContext } from "../../../infrastructure/SettingsContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TagSelectionDataControl } from "../../datacontrols/TagSelectionDataControl";
import { ApiDataAccess } from "../../common/ApiDataAccess";
import "./ArticleEditView.css";
import "@mdxeditor/editor/style.css";
import useNotifications from "../../../core/Notifications";
import { Logger } from "../../../infrastructure/Logger";
import { ArticleTagSelect } from "./controls/ArticleTagSelect";
import { Save, Upload } from "react-feather";
import { ButtonWithText } from "./controls/ButtonWithText";
import { useLoader } from "../../../core/Loader";
import MDEditor from "@uiw/react-md-editor";
import { commands } from "@uiw/react-md-editor";
import "./ArticleEditView.css";
import NiceModal from "@ebay/nice-modal-react";
import ImageUploadModal from "./ImageUploadModal";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import CreatableSelect from "react-select/creatable";

export const ArticleEditView = () => {
    const { settings } = useContext(SettingsContext);
    const [article, setArticle] = useState({
        name: "",
        content: "",
        tags: [],
        url: "",
    });

    const tagEntryDisabled = settings.TAG_ENTRY_DISBLED;
    const notifications = useNotifications();

    const tagDataAccess = new ApiDataAccess("/api/tags");

    const { articleId } = useParams();
    const navigate = useNavigate();
    const loader = useLoader();

    const [selectedTags, setSelectedTags] = useState([]);
    const [isSelectLoading, setIsSelectLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [saving, setSaving] = useState(false);

    const articleDataAccess = new ApiDataAccess("/api/articles");
    const [allTags, setAllTags] = useState([]);

    const [params] = useSearchParams();

    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
    } = useForm({
        defaultValues: {
            name: "",
            content: "",
            tags: [],
        },
        values: article,
    });

    const { fields: tags } = useFieldArray({
        control,
        name: "tags",
    });

    const loadAllTags = () => {
        return new Promise(function (resolve, reject) {
            console.log("debug: fetch all tags");
            tagDataAccess.get(
                "/",
                (data) => {
                    resolve(data);
                },
                (err) => {
                    Logger.writeError(err);
                    reject(err);
                }
            );
        });
    };

    useEffect(() => {
        loader.start("Loading");
        const loadAsync = async () => {
            if (articleId) {
                var getArticleResponse = await articleDataAccess.getAsync(`/${articleId}`);

                var tags = getArticleResponse.tags?.map((item) => {
                    return {
                        // id: item.dataObject2.id,
                        // name: item.dataObject2.name,
                        // description: item.dataObject2.description,
                        value: item.dataObject2.id,
                        label: item.dataObject2.name,
                    };
                });
                getArticleResponse.tags = tags;

                var articleData = {
                    id: getArticleResponse.id,
                    tags: tags,
                    name: getArticleResponse.name,
                    content: getArticleResponse.content,
                    url: getArticleResponse.url,
                    views: getArticleResponse.views,
                };

                setArticle(articleData);

                console.log("loaded article by id", articleId, articleData);
                setSelectedTags(
                    getArticleResponse.tags.map((tag) => {
                        console.log("!", tag);
                        return {
                            value: tag.id,
                            label: tag.name,
                        };
                    })
                );
            } else {
                console.log("new article, no id");
            }

            var getAllTagsResponse = await tagDataAccess.getAsync("/");
            setAllTags(
                getAllTagsResponse.map((item) => {
                    return {
                        value: item.id,
                        label: item.name,
                    };
                })
            );
            loader.stop();
            setLoaded(true);
        };
        loadAsync();
    }, []);

    const onSaveClick = async () => {
        loader.start("Saving...");
        setSaving(true);
        setIsSelectLoading(true);
        //Format article for back-end to work correctly with the legacy dataobjects

        var newArticle = article?.id == null;
        var articleToSave = {
            ...article,
            status: "ACT",
            tags: selectedTags.map((tag) => {
                return {
                    dataObject2Id: tag.value,
                    dataObject2: {
                        id: tag.value,
                        name: tag.label,
                    },
                };
            }),
        };
        console.log("article to save", articleToSave, newArticle);

        var saveArticleResponse = await articleDataAccess.postCallback("/", articleToSave);

        if (saveArticleResponse.ok) {
            notifications.success({
                message: `Article ${newArticle === true ? "created" : "saved"} successfully.`,
            });
            navigate(`/articles/${article.id}`, {
                replace: true,
            });
        } else {
            notifications.error({
                message: "Unexpected error saving article. Please try again in a few minutes.",
            });
        }
        setSaving(false);
        setIsSelectLoading(false);
        loader.stop();
    };

    // const onLeavingView = () => {
    //     return new Promise(function (resolve) {
    //         if (modified) {
    //             // Confirmation.show('Modified Article', 'You modified the article and will loose the changes when you leave without saving. Are you sure that you want to leave?', () => {
    //             //     resolve(true);
    //             // });
    //         } else {
    //             resolve(true);
    //         }
    //     });
    // };

    const onTagCreating = (tagToCreate) => {
        setIsSelectLoading(true);
        loader.start("Saving tag...");
        var tag = {
            id: 0,
            name: tagToCreate.trim(),
            description: "Topics concerning " + tagToCreate,
        };
        console.log("Adding");
        tagDataAccess.post(
            "/",
            tag,
            function (addTagResponse) {
                setSelectedTags([
                    ...selectedTags,
                    {
                        value: addTagResponse.id,
                        label: tagToCreate,
                    },
                ]);
                notifications.info({
                    message: "Tag created successfully.",
                });
                setIsSelectLoading(false);
                //reset all tags
                loadAllTags().then((data) => {
                    setAllTags(
                        data.map((item) => {
                            return {
                                value: item.id,
                                label: item.name,
                            };
                        })
                    );
                    loader.stop();
                });
            },
            function (error) {
                console.log(error);
                //todo: alert tag couldnt be added
                setIsSelectLoading(false);
                loader.stop();
            }
        );
    };

    const groupExample = {
        name: "upload-image",
        groupName: "upload-image",
        icon: (
            <svg viewBox="0 0 1024 1024" width="12" height="12">
                <path
                    fill="currentColor"
                    d="M716.8 921.6a51.2 51.2 0 1 1 0 102.4H307.2a51.2 51.2 0 1 1 0-102.4h409.6zM475.8016 382.1568a51.2 51.2 0 0 1 72.3968 0l144.8448 144.8448a51.2 51.2 0 0 1-72.448 72.3968L563.2 541.952V768a51.2 51.2 0 0 1-45.2096 50.8416L512 819.2a51.2 51.2 0 0 1-51.2-51.2v-226.048l-57.3952 57.4464a51.2 51.2 0 0 1-67.584 4.2496l-4.864-4.2496a51.2 51.2 0 0 1 0-72.3968zM512 0c138.6496 0 253.4912 102.144 277.1456 236.288l10.752 0.3072C924.928 242.688 1024 348.0576 1024 476.5696 1024 608.9728 918.8352 716.8 788.48 716.8a51.2 51.2 0 1 1 0-102.4l8.3968-0.256C866.2016 609.6384 921.6 550.0416 921.6 476.5696c0-76.4416-59.904-137.8816-133.12-137.8816h-97.28v-51.2C691.2 184.9856 610.6624 102.4 512 102.4S332.8 184.9856 332.8 287.488v51.2H235.52c-73.216 0-133.12 61.44-133.12 137.8816C102.4 552.96 162.304 614.4 235.52 614.4l5.9904 0.3584A51.2 51.2 0 0 1 235.52 716.8C105.1648 716.8 0 608.9728 0 476.5696c0-132.1984 104.8064-239.872 234.8544-240.2816C258.5088 102.144 373.3504 0 512 0z"
                />
            </svg>
        ),
        children: (props) => <div />,
        // children: (props) =><div style={{ display: "none"}}/>,
        execute: (state, api) => {
            NiceModal.show(ImageUploadModal, {}).then((image) => {
                if (image) {
                    console.log(image);
                    var imgMarkdown = `![${image.description}](/images/${encodeURIComponent(image.id)})`;
                    api.replaceSelection(imgMarkdown);
                }
            });
        },
        buttonProps: { "aria-label": "Upload Image" },
    };

    const onSubmit = async (data) => {
        console.log("invoked submit:::", data);
        loader.start("Saving...");
        setSaving(true);
        setIsSelectLoading(true);
        //Format article for back-end to work correctly with the legacy dataobjects

        const articleUrl = params.get("url");

        var newArticle = article?.id == null;
        var articleToSave = {
            ...article,
            name: data.name,
            content: data.content,
            status: "ACT",
            tags: data.tags.map((tag) => {
                return {
                    dataObject2Id: tag.value,
                    dataObject2: {
                        id: tag.value,
                        name: tag.label,
                    },
                };
            }),
        };
        if (articleUrl && articleUrl.trim() !== "") {
            articleToSave.url = articleUrl;
        }

        console.log("article to save", articleToSave, newArticle);

        var saveArticleResponse = await articleDataAccess.postCallback("/", articleToSave);

        if (saveArticleResponse.ok) {
            notifications.success({
                message: `Article ${newArticle === true ? "created" : "saved"} successfully.`,
            });
            var savedArticle = await saveArticleResponse.json();
            navigate(`/articles/${savedArticle.id}`, {
                replace: true,
            });
        } else {
            notifications.error({
                message: "Unexpected error saving article. Please try again in a few minutes.",
            });
        }
        setSaving(false);
        setIsSelectLoading(false);
        loader.stop();
    };

    const onError = (err) => {
        console.log("invoked submit errors:::", err);
    };

    const getReactSelectErrorBorder = (state) => {
        if (errors && errors.tags) {
            return {
                border:
                    errors && errors.tags
                        ? "1px solid #bb1128"
                        : state.isFocused
                        ? "1px solid var(--color-blue)"
                        : "1px solid",
                borderRight:
                    errors && errors.tags
                        ? "6px solid #bb1128"
                        : state.isFocused
                        ? "1px solid var(--color-blue)"
                        : "1px solid",
            };
        }

        if (state.isFocused) {
            return {
                border: "1px solid var(--color-blue)",
            };
        }

        return {
            border: "1px solid",
        };
    };

    const getReactSelectHover = (baseStyles) => {
        if (errors && errors.tags) {
            return {
                ":hover": {
                    ...baseStyles[":hover"],
                    border: "1px solid #bb1128",
                    borderRight: "6px solid #bb1128",
                },
            };
        }

        return {
            ":hover": {
                ...baseStyles[":hover"],
                border: "1px solid",
            },
        };
    };

    return (
        loaded && (
            <div className="view">
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="article-edit-section">
                        <label htmlFor="name">Title</label>
                        <input
                            // id="name"
                            {...register("name", {
                                required: true,
                            })}
                            className={`control ${errors.name && "error"}`}
                            autoComplete="off"
                            // value={article.name}
                            placeholder="Article title"
                            // onChange={(e) => {
                            //     setArticle((prev) => ({ ...prev, name: e.target.value }));
                            // }}
                        />
                        {errors.name && <span className="error">Article name is required</span>}
                    </div>
                    <div className="article-edit-section">
                        <label htmlFor="tags">Tags</label>
                        {tagEntryDisabled ? (
                            <TagSelectionDataControl propertyName="tags" />
                        ) : (
                            <Controller
                                name="tags"
                                control={control}
                                render={({ field }) => (
                                    // <ArticleTagSelect
                                    //     onChange={(val) => {
                                    //         console.log("onchange callback", val);
                                    //         field.onChange(val.value);
                                    //         //setSelectedTags(val.value);
                                    //     }}
                                    //     allTags={allTags}
                                    //     isDisabled={isSelectLoading}
                                    //     isSelectLoading={isSelectLoading}
                                    //     selectedTags={selectedTags}
                                    //     setSelectedTags={setSelectedTags}
                                    //     onTagCreating={onTagCreating}
                                    // />

                                    <div className="tag-selection">
                                        <CreatableSelect
                                            {...field}
                                            ref={field.ref}
                                            isMulti
                                            isClearable
                                            isDisabled={isSelectLoading}
                                            isLoading={isSelectLoading}
                                            placeholder="Select at least one tag"
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderRadius: "0px",
                                                    ...getReactSelectErrorBorder(state),
                                                    boxShadow:
                                                        state.isFocused && !errors.tags
                                                            ? "0 0 0 1px var(--color-blue)"
                                                            : "none",
                                                    ...getReactSelectHover(baseStyles),
                                                    // ":hover": {
                                                    //     ...baseStyles[":hover"],
                                                    //     border: "1px solid",
                                                    // },
                                                }),
                                                multiValue: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    backgroundColor: "var(--color-blue)",
                                                }),
                                                multiValueLabel: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    color: "var(--color-white)",
                                                }),
                                                multiValueRemove: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    color: "var(--color-white)",
                                                }),
                                            }}
                                            options={allTags}
                                            onCreateOption={onTagCreating}
                                        />
                                    </div>
                                )}
                                rules={{
                                    required: true,
                                }}
                            ></Controller>
                        )}
                        {errors.tags && <span className="error">At least one tag is required</span>}
                    </div>
                    <div className="article-edit-section">
                        {/* <ButtonWithText
                            disabled={article.name === "" || saving === true}
                            // onClick={onSaveClick}
                            isSubmit={true}
                        >
                            <span className="text-icon">
                                <Save />
                                <div>Save</div>
                            </span>
                        </ButtonWithText> */}
                        <button className="btn btn-primary" type="submit" disabled={saving === true}>
                            Save
                        </button>
                    </div>
                    <div className="article-edit-section">
                        <label htmlFor="content">Article Content</label>
                        <div>{errors.content && <span className="error">Content is required</span>}</div>
                        <div id="content" className="markdown-editor" data-color-mode="light">
                            <Controller
                                name="content"
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                render={({ field }) => (
                                    <MDEditor
                                        {...field}
                                        ref={(node) => {
                                            if (node && node.textarea) {
                                                field.ref = node.textarea;
                                            }
                                        }}
                                        highlightEnable={false}
                                        // onChange={field.onChange}
                                        // value={field.value}
                                        // id={field.name}
                                        // ref={field.ref}
                                        // {...field}
                                        //value={content}
                                        // onChange={(value) => {
                                        //     field.onChange(value);
                                        // }}
                                        // onChange={(updateValue) => {
                                        //     field.onChange(updateValue);
                                        //     setArticle((prev) => ({
                                        //         ...prev,
                                        //         content: updateValue,
                                        //     }));
                                        // }}
                                        height={800}
                                        commands={[...commands.getCommands(), commands.group([], groupExample)]}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </form>
            </div>
        )
    );
};
